import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import config from '../../../config';
import Footer from './Footer.vue';

VueI18nHelper.initVueI18NextForPage(Footer, `.footer-vue`, [config.locize.webshopWordpress.namespaces.FOOTER]);
